
const prod = {
    API_ROOT: 'https://vision.amygbdemos.in/api',
    SNIPPET_API_ROOT: 'https://vision.amygbdemos.in/api/upload/getSnippetText',
    SERVER_ROOT: 'https://servermonitor.amygbdemos.in/api'
}
const dev = {
    API_ROOT: 'https://vision-staging.amygbdemos.in/api',
    SNIPPET_API_ROOT: 'https://vision-staging.amygbdemos.in/api/upload/getSnippetText',
    SERVER_ROOT: 'https://servermonitor.amygbdemos.in/api'
}

export default process.env.REACT_APP_STAGE === 'development' ? dev : prod;